import { Flex, Space, Spacing, Text } from '@billy/design-system'
import { ReactElement } from 'react'

import * as Styled from './styles'

interface ExportsCardProps {
  actionButton: ReactElement
  children?: ReactElement | ReactElement[]
  description: string
  title: string
}

export const ExportsCard = ({ actionButton, children, description, title }: ExportsCardProps) => {
  return (
    <Styled.ExportsCardWrapper>
      <Flex flexDirection="column" gap={Spacing.S16}>
        <div>
          <Text variant="h4">{title}</Text>
          <Text>{description}</Text>
        </div>
        {children}
      </Flex>
      <Space size="s24" />
      {actionButton}
    </Styled.ExportsCardWrapper>
  )
}
